import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CadcontratantePage } from './cadcontratante';

@NgModule({
  declarations: [
    CadcontratantePage,
  ],
  imports: [
    IonicPageModule.forChild(CadcontratantePage),
  ],
})
export class CadcontratantePageModule {}



// WEBPACK FOOTER //
// ./src/pages/cadcontratante/cadcontratante.module.ts